import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp, Container } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { actions as behaviorActions } from "../../gamereducer/behaviourReducer";
import withBuyFeatureConfiguration from "./configuration/withbuyFeatureConfiguration";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { CURRENCY, TIMER } from "../../core/utills";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { actions as baseGameAction } from "../../core/reducers/baseGameReducer";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";
import { actions as multiplierActions } from "../../gamereducer/multiplierReducer";
import { Texture } from "pixi.js";
import { configGame, constant } from "../../data/config";
import { actions as winDropActions } from '../../gamereducer/winDropReducer';


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class BuyFeature extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected BuyFeatureContainer: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected spaceBarSpinstoreValue: boolean;
    protected multiplierValue: number = 0;

    protected optionCounter: number = 1;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.BuyFeatureContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
        this.spaceBarSpinstoreValue = false;

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    bindUI() {
        this.layoutChange(this.props.layoutMode);
        let buyFeature_closeButton: any = UIManager.getRef("buyFeature_closeButton");
        buyFeature_closeButton && (buyFeature_closeButton.visible = false)
        this.spaceBarSpinstoreValue = this.props.spinWithSpaceBar;
        this.props.buyFeatureAmountArr.length == 0 && (UIManager.getRef("BuyFeatureContainer").visible = false);
        // (window as any).GAME_INFO.jurisdiction = "uk";
        if ((window as any).GAME_INFO.jurisdiction == "uk") {
            UIManager.getRef("BuyFeatureContainer").visible = false;
        }
    }


    initializeObjectInVariable() {

    }


    componentDidMount() {
        this.initializeObjectInVariable();
        this.bindUI();
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.layoutMode !== this.props.layoutMode
            || nextProps.showBuyFeature !== this.props.showBuyFeature
            || nextProps.selectedCoin !== this.props.selectedCoin
            || nextProps.coinList !== this.props.coinList
            || nextProps.inAutoplay !== this.props.inAutoplay
            || nextProps.allButtonEnable !== this.props.allButtonEnable
            || nextProps.balance !== this.props.balance
            || nextProps.buyFeatureAmountArr !== this.props.buyFeatureAmountArr
            || nextProps.buyFeatureMaxStake !== this.props.buyFeatureMaxStake
            || nextProps.spinWithSpaceBar !== this.props.spinWithSpaceBar
            || nextProps.inFreeGame !== this.props.inFreeGame
            || nextProps.showBetHistory !== this.props.showBetHistory
            || nextProps.showGameSettings !== this.props.showGameSettings
            || nextProps.showSettingGameRules !== this.props.showSettingGameRules
            || nextProps.showSettingPanelForMobile !== this.props.showSettingPanelForMobile


        ) {
            //bonusBuyBtn_desktop

            if (nextProps.inFreeGame !== this.props.inFreeGame
                || nextProps.showBetHistory !== this.props.showBetHistory
                || nextProps.showGameSettings !== this.props.showGameSettings
                || nextProps.showSettingGameRules !== this.props.showSettingGameRules
                || nextProps.showSettingPanelForMobile !== this.props.showSettingPanelForMobile
                || nextProps.layoutMode !== this.props.layoutMode
            ) {
                let buyBtn = UIManager.getRef("bonusBuyBtn_" + this.ui_mode);

                if (nextProps.inFreeGame
                    || nextProps.showBetHistory
                    || nextProps.showGameSettings
                    || nextProps.showSettingGameRules
                    || nextProps.showSettingPanelForMobile

                ) {
                    buyBtn.visible = false;
                } else {
                    buyBtn.visible = true;
                }

            }
            if (nextProps.spinWithSpaceBar !== this.props.spinWithSpaceBar) {

                let timer = TIMER.TimerManager.createTimer(200);
                timer.on('end', (e: any, data: any) => {

                    let buyBtn = UIManager.getRef("bonusBuyBtn_" + this.ui_mode);
                    if (buyBtn.enable !== false) {

                        this.spaceBarSpinstoreValue = nextProps.spinWithSpaceBar;
                    }
                })
                timer.start();



            }
            if (nextProps.layoutMode !== this.props.layoutMode) {

                this.layoutChange(nextProps.layoutMode)
                this.showBuyFeature(nextProps.showBuyFeature);
            }

            if (nextProps.showBuyFeature && nextProps.showBuyFeature !== this.props.showBuyFeature) {
                this.showBuyFeature(nextProps.showBuyFeature);
            }

            if (nextProps.allButtonEnable && nextProps.allButtonEnable !== this.props.allButtonEnable && !nextProps.inAutoplay) {
                this.setButtonEnable();
            }
            if (!nextProps.allButtonEnable && nextProps.allButtonEnable !== this.props.allButtonEnable) {
                this.setButtonDisable();
            }

            return false;
        }

        return true;
    }

    setButtonDisable() {
        let buyBtn = UIManager.getRef("bonusBuyBtn_" + this.ui_mode);
        buyBtn.enable = false;
        buyBtn.interactive = false;
        buyBtn.texture = Texture.from("bonus_buy_disable.png");
    }
    setButtonEnable() {
        let buyBtn = UIManager.getRef("bonusBuyBtn_" + this.ui_mode);
        buyBtn.enable = true;
        buyBtn.interactive = true;
        buyBtn.texture = Texture.from("bonus_buy_up.png");
    }

    setBuyBtnDisable() {
        let leftBuyBtn = UIManager.getRef("buyBtn_left");
        leftBuyBtn.enable = false;
        leftBuyBtn.interactive = false;
        leftBuyBtn.texture = Texture.from("buy_disable.png");
        leftBuyBtn.children[0].style.fill = ["#696969"]

        let rightBuyBtn = UIManager.getRef("buyBtn_right");
        rightBuyBtn.enable = false;
        rightBuyBtn.interactive = false;
        rightBuyBtn.texture = Texture.from("buy_disable.png");
        rightBuyBtn.children[0].style.fill = ["#696969"]
    }
    setBuyBtnEnable() {
        let leftBuyBtn = UIManager.getRef("buyBtn_left");
        leftBuyBtn.enable = true;
        leftBuyBtn.interactive = true;
        leftBuyBtn.texture = Texture.from("buy_up.png");
        leftBuyBtn.children[0].style.fill = ['#a47f00', '#fdf972']

        let rightBuyBtn = UIManager.getRef("buyBtn_right");
        rightBuyBtn.enable = true;
        rightBuyBtn.interactive = true;
        rightBuyBtn.children[0].style.fill = ['#a47f00', '#fdf972']
        rightBuyBtn.texture = Texture.from("buy_up.png");
    }


    showBuyFeature(isFeatureShown: any) {

        if (isFeatureShown) {
            let buyFeatureContainer: any = UIManager.getRef("BuyFeatureMainContainer");
            let buyFeature_closeButton: any = UIManager.getRef("buyFeature_closeButton");
            let rightBuyContainer: any = UIManager.getRef("rightBuyContainer");
            let leftBuyContainer: any = UIManager.getRef("leftBuyContainer");
            let BuyFeature_Graphic: any = UIManager.getRef("BuyFeature_Graphic");
            let BuyFeature_Graphic_Portrait: any = UIManager.getRef("BuyFeature_Graphic_Portrait");

            if (isMobile && window.innerHeight > window.innerWidth) {
                BuyFeature_Graphic_Portrait && (BuyFeature_Graphic_Portrait.visible = true);
                BuyFeature_Graphic && (BuyFeature_Graphic.visible = false);
                leftBuyContainer && (leftBuyContainer.position.set(30, 450));
                rightBuyContainer && (rightBuyContainer.position.set(550, 450));
                buyFeature_closeButton && (buyFeature_closeButton.position.set(994, 33));
            } else {
                BuyFeature_Graphic && (BuyFeature_Graphic.visible = true);
                BuyFeature_Graphic_Portrait && (BuyFeature_Graphic_Portrait.visible = false);
                leftBuyContainer && (leftBuyContainer.position.set(446, 190));
                rightBuyContainer && (rightBuyContainer.position.set(974, 191));
                buyFeature_closeButton && (buyFeature_closeButton.position.set(1837, 49));
            }
            //BuyFeature_Graphic && (BuyFeature_Graphic.visible = true)
            buyFeatureContainer && (buyFeatureContainer.visible = true);
            buyFeature_closeButton && (buyFeature_closeButton.visible = true);
            leftBuyContainer && (leftBuyContainer.visible = true);
            rightBuyContainer && (rightBuyContainer.visible = true);
            this.updateAmountText(this.optionCounter);
        }
        
    }

    hideBuyFeature() {
        if (this.props.showBuyFeature) {
            let buyFeatureContainer: any = UIManager.getRef("BuyFeatureMainContainer");
            let buyFeature_closeButton: any = UIManager.getRef("buyFeature_closeButton");
            let rightBuyContainer: any = UIManager.getRef("rightBuyContainer");
            let leftBuyContainer: any = UIManager.getRef("leftBuyContainer");
            let BuyFeature_Graphic: any = UIManager.getRef("BuyFeature_Graphic");
            let BuyFeature_Graphic_Portrait: any = UIManager.getRef("BuyFeature_Graphic_Portrait");

            if (isMobile && window.innerHeight > window.innerWidth) {
                BuyFeature_Graphic_Portrait && (BuyFeature_Graphic_Portrait.visible = false)
                BuyFeature_Graphic && (BuyFeature_Graphic.visible = false)
                leftBuyContainer && (leftBuyContainer.position.set(550, 650))
                buyFeature_closeButton && (buyFeature_closeButton.position.set(994, 33))
                rightBuyContainer && (rightBuyContainer.position.set(170, 650))
            } else {
                BuyFeature_Graphic && (BuyFeature_Graphic.visible = false)
                BuyFeature_Graphic_Portrait && (BuyFeature_Graphic_Portrait.visible = false)
                leftBuyContainer && (leftBuyContainer.position.set(580, 230))
                rightBuyContainer && (rightBuyContainer.position.set(960, 230))
                buyFeature_closeButton && (buyFeature_closeButton.position.set(1837, 49))
            }
            //BuyFeature_Graphic && (BuyFeature_Graphic.visible = true)
            buyFeatureContainer && (buyFeatureContainer.visible = false)
            buyFeature_closeButton && (buyFeature_closeButton.visible = false)
            leftBuyContainer && (leftBuyContainer.visible = false)
            rightBuyContainer && (rightBuyContainer.visible = false)
            this.setButtonEnable();
        }

    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }

    updateAmountText(options?: any) {
        let amountleft = UIManager.getRef('left_buy_text');
        let amountright = UIManager.getRef('right_buy_text');
        let rightAmount = CURRENCY.CurrencyManager.formatCurrencyString(this.props.buyFeatureAmountArr[0].stakeScale * this.props.coinList[this.props.selectedCoin], true, true, true, true);
        rightAmount = this.correctCurrencyCodeXAF(rightAmount);

        let leftAmount = CURRENCY.CurrencyManager.formatCurrencyString(this.props.buyFeatureAmountArr[options].stakeScale * this.props.coinList[this.props.selectedCoin], true, true, true, true);
        leftAmount = this.correctCurrencyCodeXAF(leftAmount);

        amountright && (UIManager.setText("right_buy_text", leftAmount));
        amountleft && (UIManager.setText("left_buy_text", rightAmount));
        let freeSpinCountText = UIManager.getRef("right_15_text");
        let freeTextVal = this.props.buyFeatureAmountArr[options].spins + " " + this.props.langObj["buyInNumber1"]
        freeSpinCountText && (UIManager.setText("right_15_text", freeTextVal));

        let freeSpinCountTextLeft = UIManager.getRef("left_15_text");
        freeSpinCountTextLeft && (UIManager.setText("left_15_text", "15 " + this.props.langObj["buyInNumber1"]));

        let multiplier = UIManager.getRef("right_X_text");
        let mulValue = this.props.buyFeatureAmountArr[options].optionString == 1 ? 5 : 1;
        let multiplierVal = "X" + mulValue;
        multiplier && (UIManager.setText("right_X_text", multiplierVal));
        this.multiplierValue = mulValue;
    }

    setLocalStorageForBuyFeature(targetName: any) {
        // Here by mistake right container is left and left is right
        if (targetName === "buyBtn_left") {
            // localStorage.setItem("buyInFeature_local", "true")
            // localStorage.setItem("buyInValue_local", (this.props.buyFeatureAmountArr[0].stakeScale * 100 * this.props.coinList[this.props.selectedCoin]).toString())
            // localStorage.setItem("selection_local", "0")

            constant.configGame.buyInFeature_local = true;
            constant.configGame.buyInValue_local = (this.props.buyFeatureAmountArr[0].stakeScale * 100 * this.props.coinList[this.props.selectedCoin]).toString();
            constant.configGame.selection_local = "0";
            this.props.setBuyInFeatureAmtDeduct(this.props.buyFeatureAmountArr[0].stakeScale * this.props.coinList[this.props.selectedCoin]);
        }
        if (targetName === "buyBtn_right") {
            // localStorage.setItem("buyInFeature_local", "true")
            // localStorage.setItem("buyInValue_local", (this.props.buyFeatureAmountArr[this.optionCounter].stakeScale * 100 * this.props.coinList[this.props.selectedCoin]).toString())
            // localStorage.setItem("selection_local", this.optionCounter.toString())

            constant.configGame.buyInFeature_local = true;
            constant.configGame.buyInValue_local = (this.props.buyFeatureAmountArr[this.optionCounter].stakeScale * 100 * this.props.coinList[this.props.selectedCoin]).toString();
            constant.configGame.selection_local = this.optionCounter.toString();
            this.props.setBuyInFeatureAmtDeduct(this.props.buyFeatureAmountArr[this.optionCounter].stakeScale * this.props.coinList[this.props.selectedCoin]);
        }

        this.hideBuyFeature();
        this.props.setBuyFeatureClicked(false);
        this.props.setAllButtonEnable()
    }


    handleEvent = (e: any) => {
        let FWReelData: any;
        let convertCurrentStake;
        let converMaxbet;
        switch (e.target.name) {
            case "buyBtn_right":
                this.props.setMultiplierForBuyFeature(true);
                this.props.storeMultiplierValue(this.multiplierValue);
                convertCurrentStake = this.props.coinList[this.props.selectedCoin] * (window as any).GAME_INFO.ex_rate;
                converMaxbet = (this.props.buyFeatureMaxStake / 10) / 10;
                if (convertCurrentStake > converMaxbet) {
                    this.props.setBuyFeatureStakeExceeds(true);

                } else {
                    this.props.spaceBarSpin(false);

                    if (this.props.balance - this.props.buyFeatureAmountArr[this.optionCounter].stakeScale * this.props.coinList[this.props.selectedCoin] < 0) {
                        this.props.setInsufficientFunds(true);
                    } else {
                        this.setLocalStorageForBuyFeature(e.target.name)

                        FWReelData = {
                            stopReelsAfterWin: [],
                            stopReels: [],
                            wins: [],
                            balance: this.props.balance,
                            winAmount: 0,
                            feature: [1],
                            featureType: "FREEGAME",
                            freegameSpinCount: 1,
                            freegameSpinCountWin: this.props.buyFeatureAmountArr[this.optionCounter].spins,
                            freegameSpinCountRemaining: this.props.buyFeatureAmountArr[this.optionCounter].spins,
                        }
                        this.props.setBaseGameSpinSucces(FWReelData);
                        this.props.setFreeeGameSpinSucces(FWReelData);
                        this.props.flowManagerCalled(true);
                        this.props.setWinDropList([]);
                    }
                }

                return;
            case "buyBtn_left":
                this.props.setMultiplierForBuyFeature(true);
                this.props.storeMultiplierValue(1);
                this.props.setBuyFeatureStakeExceeds(false);
                this.props.spaceBarSpin(false);
                if (this.props.balance - this.props.buyFeatureAmountArr[0].stakeScale * this.props.coinList[this.props.selectedCoin] < 0) {
                    this.props.setInsufficientFunds(true);
                } else {
                    this.setLocalStorageForBuyFeature(e.target.name)

                    FWReelData = {
                        stopReelsAfterWin: [],
                        stopReels: [],
                        wins: [],
                        balance: this.props.balance,
                        winAmount: 0,
                        feature: [1],
                        featureType: "FREEGAME",
                        freegameSpinCount: 1,
                        freegameSpinCountWin: this.props.buyFeatureAmountArr[0].spins,
                        freegameSpinCountRemaining: this.props.buyFeatureAmountArr[0].spins,
                    }
                    this.props.setBaseGameSpinSucces(FWReelData);
                    this.props.setFreeeGameSpinSucces(FWReelData);
                    this.props.flowManagerCalled(true);
                    this.props.setWinDropList([]);
                }

                return;
            case "bonusBuyBtn_" + this.ui_mode:
                this.props.spaceBarSpin(false);
                // localStorage.setItem("selection_local", "-1")
                constant.configGame.selection_local = "-1";
                this.props.flowManagerCalled(false);
                this.props.setBuyInFeatureAmtDeduct(0);
                this.props.setBuyFeatureClicked(true);
                this.props.setAllButtonDisable()

                convertCurrentStake = this.props.coinList[this.props.selectedCoin] * (window as any).GAME_INFO.ex_rate;
                converMaxbet = (this.props.buyFeatureMaxStake / 10) / 10;
                if (convertCurrentStake > converMaxbet) {
                    this.props.setBuyFeatureStakeExceeds(true);
                    this.setBuyBtnDisable();

                } else {
                    this.setBuyBtnEnable();
                }


                return;
            case "buyFeature_closeButton":
                this.hideBuyFeature();
                this.props.setInsufficientFunds(false);
                this.props.setBuyInFeatureAmtDeduct(0);
                this.props.setBuyFeatureClicked(false);
                this.props.setAllButtonEnable();
                this.props.spaceBarSpin(this.spaceBarSpinstoreValue);
                return;
            case "arrowBtn_back":
                if (this.optionCounter > 1) {
                    this.optionCounter--
                }
                this.updateAmountText(this.optionCounter)
                return;
            case "arrowBtn_next":
                if (this.optionCounter < 3) {
                    this.optionCounter++
                }
                this.updateAmountText(this.optionCounter)
                return;

            default:
                return 'No buttons';
        }
    }


    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }

    render() {

        return (
            <UIManager id={"BuyFeatureContainer"} name={"BuyFeatureContainer"} type={"Container"}
                ref={i => this.BuyFeatureContainer = i} configGame={this.props.configGame}
                app={this.app} >
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame} ClickHandler={this.handleEvent}

                            scope={this} />
                    )
                }
            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'mainSettingPanelState' | 'freegameState' | 'keyboardListenerState' | 'applicationState' | 'buttonPanelState' | 'basegameState' | 'betPanelState' | 'behaviourState' | 'basegameState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        showBuyFeature: state.behaviourState.showBuyFeature,
        buyFeatureAmountArr: state.behaviourState.buyFeatureAmountArr,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,
        inAutoplay: state.basegameState.inAutoplay,
        allButtonEnable: state.buttonPanelState.allButtonEnable,
        balance: state.basegameState.balance,
        buyFeatureMaxStake: state.behaviourState.buyFeatureMaxStake,
        spinWithSpaceBar: state.keyboardListenerState.spinWithSpaceBar,
        inFreeGame: state.freegameState.inFreeGame,
        showBetHistory: state.behaviourState.showBetHistory,
        showGameSettings: state.behaviourState.showGameSettings,
        showSettingGameRules: state.behaviourState.showSettingGameRules,
        showSettingPanelForMobile: state.mainSettingPanelState.showSettingPanelForMobile
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setBuyInFeatureAmtDeduct: (buyInFeatureDeductAmt: any): any => dispatch(behaviorActions.setBuyInFeatureAmtDeduct(buyInFeatureDeductAmt)),
        setBuyFeatureClicked: (showBuyFeature: any): any => dispatch(behaviorActions.setBuyFeatureClicked(showBuyFeature)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        setFreeeGameSpinSucces: (result_spin: any): any => dispatch(freegameAction.setFreeeGameSpinSucces(result_spin)),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        setBaseGameSpinSucces: (result_spin: any): any => dispatch(baseGameAction.setBaseGameSpinSucces(result_spin)),
        reTriggeredFreegame: (): any => dispatch(freegameAction.reTriggeredFreegame()),
        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(baseGameAction.setApplicationToBaseGameState(basegamestate)),
        setInsufficientFunds: (insuffFunds: any): any => dispatch(behaviorActions.setInsufficientFunds(insuffFunds)),
        setBuyFeatureStakeExceeds: (betExceeds: any): any => dispatch(behaviorActions.setBuyFeatureStakeExceeds(betExceeds)),
        spaceBarSpin: (spinWithSpaceBar: boolean): any => dispatch(keyboardListenerActions.spaceBarSpin(spinWithSpaceBar)),
        storeMultiplierValue: (storeMultiplierCurrentValue: any): any => dispatch(multiplierActions.storeMultiplierValue(storeMultiplierCurrentValue)),
        setMultiplierValue: (multiplierCurrentValue: any): any => dispatch(multiplierActions.setMultiplierValue(multiplierCurrentValue)),
        activeMultiplier: (multiplierActive: boolean): any => dispatch(multiplierActions.activeMultiplier(multiplierActive)),
        setMultiplierForBuyFeature: (updateMultiplierForBuyFeature: any): any => dispatch(behaviorActions.setMultiplierForBuyFeature(updateMultiplierForBuyFeature)),
        setWinDropList: (dropList: any): any => dispatch(winDropActions.setWinDropList(dropList)),
    }))(withBuyFeatureConfiguration(BuyFeature)));